module.exports = __webpack_public_path__ + "static/media/info-collection-bg.2e60630f.svg";